// extracted by mini-css-extract-plugin
export default {"modal-header":"GenerateNhimaModal_modal-header__YT-Q4","close-icon":"GenerateNhimaModal_close-icon__vJNOq","modal-body":"GenerateNhimaModal_modal-body__8mQG5"};